import { useState, useEffect } from "react";

function useCurrentTopUpCampaign(
  loadForSpecificTreatmentCategoryAndPurchaseMode,
  treatmentCategory,
  purchaseMode
) {
  const [currentTopUpCampaign, setCurrentTopUpCampaign] = useState({});
  const [loading, setLoading] = useState(true);

  const loadCurrentTopUpCampaign = () => {
    setLoading(true);
    $.getJSON("/top_up_campaigns/current").then((campaign) => {
      if (campaign && campaign.top_up_campaign_items) {
        const data = { show_disabled: true };

        if (treatmentCategory) {
          data.treatment_category = treatmentCategory;
        }

        if (purchaseMode) {
          data.purchase_mode = purchaseMode;
        }

        $.getJSON("/products", data).then((products) => {
          // filter out items that do not have an associated product
          campaign.top_up_campaign_items =
            campaign.top_up_campaign_items.filter((item) => {
              item.product = products.find(
                (product) =>
                  product.square_item_variation_id ===
                  item.square_item_variation_id
              );
              if (item.product) {
                return item;
              } else {
                return null;
              }
            });

          // sort by price
          campaign.top_up_campaign_items.sort(
            (a, b) => a.product.price - b.product.price
          );

          // set the current top up campaign to the filtered and sorted campaign
          setCurrentTopUpCampaign(campaign);
          setLoading(false);
        });
      }
    });
  };

  useEffect(() => {
    if (!loadForSpecificTreatmentCategoryAndPurchaseMode) {
      loadCurrentTopUpCampaign();
    }
  }, []);

  useEffect(() => {
    if (
      loadForSpecificTreatmentCategoryAndPurchaseMode &&
      treatmentCategory &&
      purchaseMode
    ) {
      loadCurrentTopUpCampaign();
    }
  }, [treatmentCategory, purchaseMode]);

  return { currentTopUpCampaign, loading };
}

export default useCurrentTopUpCampaign;
